/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ParkingRightTypeEnum = {
    DurationBased: 'DurationBased',
    TimeBased: 'TimeBased'
} as const;
export type ParkingRightTypeEnum = typeof ParkingRightTypeEnum[keyof typeof ParkingRightTypeEnum];

